import { useState , useContext} from 'react';

import './BiometricIDLogin.scss';
import DetailsMain from '../../../General/Details/DetailsMain';
import BiometricIDInstall from './Install/BiometricIDInstall';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../General/Static/Header';
import arrowLeftBlue from '../../../../assets/icons/arrow-left-blue.svg';
import ladyArt from '../../../../assets/img/wizard_bg.svg';
import guyWithLaptop from '../../../../assets/img/biometric_bg.png';
import LoginContext from '../../../../store/login-context';
import PassKeyMarket from '../../PassKey/PassKeyMarket';

declare function Translate(key: string): string;
declare var _curLang: any;
declare var _loginType: any;
declare var _loginTypeIsraelDigitalIDCard: any;

const BiometricIDLogin = props => {

  const ctx = useContext(LoginContext);

  const [installProcess, setInstallProcess] = useState(true);
  const [neededInfo, setNeededInfo] = useState<string[]>([]);
  const [isDetailsCompleted, setIsDetailsCompleted] = useState(false);

  const update = () => {
    props.forceUpdate();
  };

  const onInstalledProccessFinished = (neededInfoParam: any) => {    
    if (neededInfoParam !== undefined && neededInfoParam.length > 0) {
      setInstallProcess(false);
      setNeededInfo(neededInfoParam);  
      if(neededInfoParam.length === 1 && neededInfoParam[0] === ''){
        onDetailsCompleted();
      }      
    } 

    // if (neededInfoParam !== undefined && neededInfoParam[0].trim().length === 0) {
    //   setIsDetailsCompleted(true);
    // }
  };

  const onDetailsCompleted = () => {
    // setIsDetailsCompleted(true);
    localStorage.setItem('preferredLoginType', _loginTypeIsraelDigitalIDCard ); 
    ctx.setSuccess();
  };

  return (
    <Container fluid className='px-0'>
      <Header
        showLogo={true}
        forceUpdate={update}
        isBiometricHeader={true}
      />      
      <Row className='left-side'>
        <Col
          className='side-bg ps-0 pe-0'
          xl={5}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <div className='main-top-container'>
            <div
              className='side-upper'
              style={isDetailsCompleted ? { display: 'none' } : {}}
            >
              {installProcess ? (
                <div className='title-container'>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <div className='side-title mb-2' role="heading" aria-level={2}>
                      {Translate('N_Login_Bio_ID_title')}
                    </div>
                    <div className='side-text'>
                      {Translate('N_Login_Bio_ID_info')}
                    </div>
                    <div className='d-flex align-items-center mt-3'>
                      <a className='bIdLoginAnchor' href={document.referrer}>
                        {Translate('N_Login_Bio_ID_button')}
                      </a>
                      &nbsp;&nbsp;
                      <img src={arrowLeftBlue} aria-hidden="true" />
                    </div>
                  </Col>
                </div>
              ) : (
                <Row
                  className={
                    _curLang === 'en' || _curLang === 'ru'
                      ? 'justify-content-start'
                      : 'justify-content-end'
                  }
                >
                  {!isDetailsCompleted ? (
                    <Col
                      xl={_curLang === 'en' || _curLang === 'ru' ? 12 : 5}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                    >
                      <div className='side-title mb-2' role="heading" aria-level={2}>
                        {Translate('N_Login_Bio_ID_registration-title')}
                      </div>
                      <div className='side-text'>
                        {Translate('N_Login_Bio_ID_registration-subtitle')}
                      </div>
                      <div className='side-text'>
                        {Translate('N_Login_Bio_ID_registration-subtitle_1')}
                      </div>
                    </Col>
                  ) : null}
                </Row>
              )}
            </div>
            <img
              src={installProcess ? guyWithLaptop : ladyArt}
              aria-hidden="true"
              className={
                installProcess ? 'guyWithLaptop' : 'ladyArt'
              }
              
            />
          </div>
        </Col>

        <Col
          xl={7}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className='left-container'
        >
          {installProcess ? (
            <BiometricIDInstall              
              onProcessFinished={(neededInfo) =>
                onInstalledProccessFinished(neededInfo)
              }
            />
          ) : neededInfo.length > 0  && neededInfo[0] !== '' &&
              <DetailsMain                
                neededInfo={neededInfo}
                detailsCompleted={onDetailsCompleted}
              />
          }
        </Col>
      </Row>
       {/* } */}
     
    </Container>
  );


};
export default BiometricIDLogin;

